import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter} from 'rxjs/operators';
import {OAuthService} from 'angular-oauth2-oidc';

export interface CurrentUser {
  email: string;
  userName: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private readonly currentUserSubject: BehaviorSubject<CurrentUser | null>;
  currentUser$!: Observable<CurrentUser | null>;

  constructor(private oauthService: OAuthService) {
    this.currentUserSubject = new BehaviorSubject<CurrentUser | null>(null);
    this.currentUser$ = this.currentUserSubject.asObservable();

    this.oauthService.events.pipe(
      filter(e => e.type === 'token_received' || e.type === 'token_refreshed')
    ).subscribe(() => this.loadFromClaims());

    this.loadFromClaims();
  }

  private loadFromClaims(): void {
    const claims = this.oauthService.getIdentityClaims() as Record<string, any> | null;
    if (!claims) {
      this.currentUserSubject.next(null);
      return;
    }

    const firstName = claims['given_name'] ?? '';
    const lastName = claims['family_name'] ?? '';
    const user: CurrentUser = {
      email: claims['email'] ?? '',
      userName: claims['preferred_username'] ?? '',
      firstName,
      lastName,
      fullName: claims['name'] ?? ([firstName, lastName].filter(Boolean).join(' ') || (claims['preferred_username'] ?? '')),
    };
    this.currentUserSubject.next(user);
  }

  getCurrentUser(): Observable<CurrentUser | null> {
    return this.currentUser$;
  }

  clearCurrentUser(): void {
    this.currentUserSubject.next(null);
  }
}
